(() => {
  if (window.ohCartServicesBound) return;
  window.ohCartServicesBound = true;
  const selector = '#oh-sp-toggle,#gift-wrap-checkbox,[data-oh-brand-bag-cb]';
  const root = window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  let giftTimer;
  let pending = false;
  const locked = new Map();
  function lock() {
    pending = true;
    document.querySelectorAll(selector + ',button[name="checkout"],input[name="checkout"],cart-drawer quantity-selector input,cart-drawer quantity-selector button,.shopify-section--main-cart quantity-selector input,.shopify-section--main-cart quantity-selector button,cart-discount-field input,cart-discount-field button').forEach(el => {
      if (!locked.has(el)) locked.set(el, el.disabled);
      el.disabled = true;
    });
  }
  function unlock() {
    locked.forEach((disabled, el) => { if (el.isConnected) el.disabled = disabled; });
    locked.clear();
    pending = false;
  }
  document.addEventListener('click', event => {
    if (pending && event.target.closest?.('a[href*="/cart/change"],[name="checkout"]')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', event => {
    if (pending && event.target.matches('form[action$="/cart"],form[action$="/cart/"]')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  const live = document.createElement('p');
  live.className = 'sr-only';
  live.setAttribute('role', 'status');
  live.setAttribute('aria-live', 'polite');
  document.body.append(live);

  function revealFocusedControl() {
    const active = document.activeElement;
    if (!active?.matches('input,select,textarea,button,a') || !active.closest('cart-drawer[open]')) return;
    for (let node = active; node; node = node.assignedSlot || node.parentElement || node.getRootNode().host) {
      if (node.scrollHeight <= node.clientHeight || !/auto|scroll/.test(getComputedStyle(node).overflowY)) continue;
      const box = active.getBoundingClientRect(), viewport = node.getBoundingClientRect();
      const delta = box.top < viewport.top + 12 ? box.top - viewport.top - 12 : box.bottom > viewport.bottom - 12 ? box.bottom - viewport.bottom + 12 : 0;
      if (delta) node.scrollTop += delta;
      break;
    }
  }
  let revealFrame;
  function scheduleReveal() {
    cancelAnimationFrame(revealFrame);
    revealFrame = requestAnimationFrame(revealFocusedControl);
  }
  window.addEventListener('resize', scheduleReveal, {passive: true});
  window.visualViewport?.addEventListener('resize', scheduleReveal, {passive: true});
  document.addEventListener('focusin', scheduleReveal);

  async function request(path, data) {
    const response = await fetch(root + path, {
      credentials: 'same-origin', cache: 'no-store',
      ...(data ? {method: 'POST', headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: JSON.stringify(data)} : {})
    });
    if (!response.ok) throw new Error('cart-request');
    return response.json();
  }

  function fields(scope) {
    return [...scope.querySelectorAll('textarea[id],input[id]:not([type="hidden"]),select[id]')]
      .filter(el => !el.matches(selector) && !el.closest('quantity-selector'))
      .map(el => ({id: el.id, value: el.value, checked: el.checked, start: el.selectionStart, end: el.selectionEnd}));
  }

  function restore(scope, saved) {
    saved.forEach(field => {
      const el = document.getElementById(field.id);
      if (!el || !scope.contains(el)) return;
      if (el.type === 'checkbox' || el.type === 'radio') el.checked = field.checked;
      else el.value = field.value;
      if (typeof field.start === 'number' && el.setSelectionRange) {
        try { el.setSelectionRange(field.start, field.end); } catch (_) {}
      }
    });
  }

  function hideServiceLines() {
    document.querySelectorAll('a[href*="shipping-protection"]').forEach(link => {
      const row = link.closest('tr') || link.closest('line-item') || link.closest('.line-item');
      if (row) row.setAttribute('data-oh-sp-hidden', '');
    });
  }

  function context(input) {
    const drawer = input.closest('cart-drawer');
    const parent = input.closest('.shopify-section');
    const id = parent?.id.replace('shopify-section-', '') || document.querySelector('#oh-shipping-protection')?.dataset.sectionId;
    const section = parent || document.getElementById('shopify-section-' + id);
    if (!id || (!drawer && !section)) throw new Error('cart-section');
    return {drawer, section, id, sectionDomId: 'shopify-section-' + id};
  }

  function target(input, cart) {
    if (input.id === 'oh-sp-toggle') {
      const variants = JSON.parse(input.closest('#oh-shipping-protection').dataset.variants);
      const subtotal = cart.items.reduce((sum, line) => sum + (line.handle === 'shipping-protection' ? 0 : line.final_line_price), 0);
      const price = Math.round(subtotal * 5 / 100);
      const selected = variants.reduce((best, item) => !best || Math.abs(item.price - price) < Math.abs(best.price - price) ? item : best, null);
      return {id: selected?.id, lines: cart.items.filter(line => line.handle === 'shipping-protection')};
    }
    const id = Number(input.dataset.variantId);
    return {id, lines: cart.items.filter(line => Number(line.variant_id) === id)};
  }

  async function renderedSections(cart, ctx) {
    if (cart.sections?.[ctx.id]) return;
    const url = new URL(location.href);
    url.searchParams.set('sections', ctx.id);
    const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store'});
    if (!response.ok) throw new Error('cart-render');
    cart.sections = {...cart.sections, ...await response.json()};
    if (!cart.sections[ctx.id]) throw new Error('cart-render');
  }

  async function render(cart, ctx, focusedId) {
    await renderedSections(cart, ctx);
    const parsed = new DOMParser().parseFromString(cart.sections[ctx.id], 'text/html');
    const incoming = parsed.getElementById(ctx.sectionDomId);
    if (!incoming) throw new Error('cart-markup');
    const scope = ctx.drawer || ctx.section;
    const saved = fields(scope);
    const scroll = [...scope.querySelectorAll('*')].filter(el => el.scrollTop > 0)
      .map(el => ({id: el.id, className: el.className, top: el.scrollTop}));
    const active = document.activeElement;
    const focusId = scope.contains(active) ? active.id : active === document.body ? focusedId : null;
    if (ctx.drawer) {
      if (!incoming.querySelector('cart-drawer')) throw new Error('cart-drawer-markup');
      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => { ctx.drawer.removeEventListener('cart-drawer:refreshed', done); reject(new Error('cart-render-timeout')); }, 8000);
        function done() { clearTimeout(timeout); resolve(); }
        ctx.drawer.addEventListener('cart-drawer:refreshed', done, {once: true});
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles: true, detail: {baseEvent: 'service:change', cart}}));
      });
    } else {
      for (const part of ['[data-oh-cart-lines]', '[data-oh-cart-totals]']) {
        if (!scope.querySelector(part) || !incoming.querySelector(part)) throw new Error('cart-page-markup');
      }
      for (const part of ['[data-oh-cart-lines]', '[data-oh-cart-totals]', '.cart-header free-shipping-bar', '#oh-shipping-protection']) {
        const current = scope.querySelector(part), next = incoming.querySelector(part);
        if (current && next) current.replaceWith(next);
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles: true, detail: {baseEvent: 'service:change', cart}}));
    }
    restore(scope, saved);
    scope.querySelectorAll(selector).forEach(input => {
      input.checked = target(input, cart).lines.length > 0;
    });
    const gift = scope.querySelector('#gift-wrap-message-container');
    if (gift) gift.style.display = scope.querySelector('#gift-wrap-checkbox')?.checked ? 'block' : 'none';
    const giftMessage = scope.querySelector('#gift-wrap-message');
    if (giftMessage) giftMessage.disabled = !scope.querySelector('#gift-wrap-checkbox')?.checked;
    hideServiceLines();
    document.dispatchEvent(new CustomEvent('cart:updated'));
    scroll.forEach(saved => {
      const el = saved.id ? document.getElementById(saved.id) : [...scope.querySelectorAll('*')].find(el => el.className === saved.className);
      if (el) el.scrollTop = saved.top;
    });
    if (focusId) {
      const destination = document.getElementById(focusId);
      if (destination?.matches(selector)) destination.disabled = false;
      destination?.focus({preventScroll: true});
    }
    scheduleReveal();
    const widget = scope.querySelector('#oh-shipping-protection');
    live.textContent = widget ? widget.dataset.totalLabel + ' ' + widget.dataset.total : '';
  }

  async function update(input, wanted, focusedId) {
    let ctx;
    const wrapper = input.closest('#oh-shipping-protection,#gift-wrap-container,[data-brand-bag]');
    const previous = !wanted;
    wrapper?.setAttribute('aria-busy', 'true');
    const errorText = document.querySelector('#oh-shipping-protection')?.dataset.error || '';
    let failed = false;
    try {
      ctx = context(input);
      const cart = await request('cart.js');
      const selection = target(input, cart);
      if (!Number.isSafeInteger(selection.id) || selection.id <= 0) throw new Error('service-variant');
      const sections = new Set([ctx.id]);
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {bubbles: true, detail: {sections}}));
      const bundled = {sections: [...sections].slice(0, 5), sections_url: location.pathname};
      let result;
      if (wanted && !selection.lines.length) result = await request('cart/add.js', {...bundled, items: [{id: selection.id, quantity: 1}]});
      else if (!wanted && selection.lines.length) {
        const updates = Object.fromEntries(selection.lines.map(line => [line.key, 0]));
        const attributes = input.id === 'gift-wrap-checkbox' ? {gift_message: ''} : undefined;
        result = await request('cart/update.js', {...bundled, updates, ...(attributes ? {attributes} : {})});
      }
      const current = await request('cart.js');
      current.sections = result?.sections;
      await render(current, ctx, focusedId);
      if (input.id === 'gift-wrap-checkbox' && !wanted) {
        const field = document.getElementById('gift-wrap-message');
        if (field) field.value = '';
        const count = document.getElementById('gift-msg-count');
        if (count) count.textContent = '0';
      }
    } catch (_) {
      failed = true;
      try {
        if (!ctx) throw new Error('cart-context');
        const current = await request('cart.js');
        const confirmed = target(input, current).lines.length > 0;
        await render(current, ctx, focusedId);
        failed = confirmed !== wanted;
      } catch (_) {
        const currentInput = document.getElementById(input.id);
        if (currentInput) currentInput.checked = previous;
      }
    } finally {
      unlock();
      document.querySelectorAll('[aria-busy="true"]').forEach(el => { if (el.matches('#oh-shipping-protection,#gift-wrap-container,[data-brand-bag]')) el.removeAttribute('aria-busy'); });
      if (failed) {
        const status = document.querySelector('#oh-cart-service-error');
        if (status) { status.hidden = false; status.querySelector('[data-service-error-message]').textContent = errorText; }
      }
    }
  }

  document.addEventListener('change', event => {
    const input = event.target.closest?.(selector);
    if (!input) return;
    const wanted = input.checked, focusedId = document.activeElement?.id;
    if (input.id === 'gift-wrap-checkbox' && !wanted) clearTimeout(giftTimer);
    const status = document.querySelector('#oh-cart-service-error');
    if (status) { status.hidden = true; status.querySelector('[data-service-error-message]').textContent = ''; }
    lock();
    queue = queue.then(() => update(document.getElementById(input.id) || input, wanted, focusedId)).catch(() => {
      unlock();
    });
  });

  document.addEventListener('input', event => {
    if (event.target.id !== 'gift-wrap-message') return;
    const count = document.getElementById('gift-msg-count');
    if (count) count.textContent = String(event.target.value.length);
    const message = event.target.value;
    clearTimeout(giftTimer);
    giftTimer = setTimeout(() => {
      queue = queue.then(async () => {
        if (!document.getElementById('gift-wrap-checkbox')?.checked) return;
        const status = document.querySelector('#oh-cart-service-error');
        if (status) { status.hidden = true; status.querySelector('[data-service-error-message]').textContent = ''; }
        lock();
        document.getElementById('gift-wrap-container')?.setAttribute('aria-busy', 'true');
        try {
          const cart = await request('cart/update.js', {attributes: {gift_message: message}});
          if ((cart.attributes?.gift_message || '') !== message) throw new Error('gift-message-save');
        } finally {
          unlock();
          document.getElementById('gift-wrap-container')?.removeAttribute('aria-busy');
        }
      }).catch(() => {
        const status = document.querySelector('#oh-cart-service-error');
        if (status) { status.hidden = false; status.querySelector('[data-service-error-message]').textContent = document.querySelector('#oh-shipping-protection')?.dataset.error || ''; }
      });
    }, 800);
  });
  document.addEventListener('cart-drawer:refreshed', hideServiceLines);
  hideServiceLines();
})();
